const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

import {logoVoxfeedThumbnailBlackImg as defaultPhoto} from 'assets/images';

const TeamMember = createClass({

  propTypes: {
    photo: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string
  },

  getDefaultProps() {
    return {
      photo: {
        url: defaultPhoto
      }
    };
  },

  render() {
    return (
      <li>
        <img src={this.props.photo.url} alt='Photo' />
        <a className='team-name'>{this.props.name}</a>
        <span className='team-envelope'>{this.props.title}</span>
      </li>
    );
  }
});

module.exports = TeamMember;
